var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.booking && _vm.booking.canceled)?_c('booking-status-canceled',{staticStyle:{"margin":"1px"}}):_c('computed-status-badge',{staticStyle:{"margin":"1px"},attrs:{"status-list":_vm.allBookingStatus,"value":_vm.computedStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }